import fieldsSlices from './fields';
import growersSlices from './growers';
import seasonsSlices from './seasons';

const gffSlices = [fieldsSlices, seasonsSlices, growersSlices];

export default gffSlices;
